import { all, takeEvery, takeLatest, call, put } from 'redux-saga/effects';
import actions from './actions';
import { getQuestionnaires, postQuestionnaire, getQuestion, postQuestion, getKarieUsers, assignToPatient, deleteQuestionnaire, deleteQuestion, putQuestionnaire } from '../../../api/questionnaire/questionnaire';

//TODO: Call Success and fail actions after API response

async function questionnairePostRequest(questionnaire) {
    return postQuestionnaire({ title: questionnaire.title, description: questionnaire.description, startDate: parseInt(questionnaire.start_date, 10), endDate: parseInt(questionnaire.end_date, 10) });
}

function questionnairesGetRequest() {
    return getQuestionnaires({ questionnaireId: null, limit: 100, offset: null, sort: null, startDateRange: null, endDateRange: null, title: null });
}

function* fetchRequest() {
    try {
        const response = yield call(questionnairesGetRequest);
        yield put(actions.fetchQuestionnairesSuccess(response.questionnaires));
    } catch (error) {
        console.log(error);
    }
}

function* createRequest({questionnaire, history }) {
    try {
        const response = yield call(questionnairePostRequest, questionnaire);
        yield put(actions.createQuestionnaireSuccess(response.questionnaire));
        history.push('/dashboard/questionnaires/builder/' + response.questionnaire.questionnaireId + '/manage');
    } catch (error) {
        console.log(error);
    }
}
function questionnairePutRequest(questionnaireId, questionnaire) {
    return putQuestionnaire({questionnaireId: questionnaireId, title: questionnaire.title, description: questionnaire.description, startDate: (questionnaire.start_date === "" ? null : parseInt(questionnaire.start_date, 10)), endDate: (questionnaire.start_date === "" ? null : parseInt(questionnaire.end_date, 10))});
}

function* editQuestionnaireRequest({ questionnaireId, questionnaire, history }) {

    try {
        const response = yield call(questionnairePutRequest, questionnaireId, questionnaire);
        yield put(actions.createQuestionnaireSuccess(response.questionnaire));
        history.push('/dashboard/questionnaires');
    } catch (error) {
        console.log(error);
    }
}

function questionnaireDeleteRequest(questionnaireId) {
    return deleteQuestionnaire(questionnaireId);
}

function* deleteQuestionnaireRequest({ questionnaireId, resolve, reject}) {
    try {
        const response = yield call(questionnaireDeleteRequest, questionnaireId);
        if (response.message === "Deleted") {
            yield put(actions.fetchQuestionnaires());
            resolve();
        } else {
            //TODO: handle delete failure here
            reject();
        }

    } catch (error) {
        console.log(error);
    }
}

function questionPostRequest(question, questionnaireId) {
    return postQuestion(questionnaireId, { text: question.text, description: question.description, allowMultiple: question.allowMultiple, orderNumber: question.orderNumber, required: question.required, type: question.type, answerOptions: question.answerOptions });
}

function* createQuestionRequest({ question, questionnaireId, history }) {
    try {
        const response = yield call(questionPostRequest, question, questionnaireId);
        history.push('/dashboard/questionnaires/builder/' + response.question.questionnaireId + '/manage');
    } catch (error) {
        console.log(error);
    }
}

function questionsGetRequest(questionnaireId) {
    return getQuestion(questionnaireId, {questionId: null, limit: 100, offset: null, sort: ">modifiedAt"});
}

function* fetchQuestionsRequest({ questionnaireId }) {
    try {
        const response = yield call(questionsGetRequest, questionnaireId);
        yield put(actions.fetchQuestionsSuccess(response.questions));
    } catch (error) {
        console.log(error);
    }
}

function* fetchKarieUsersRequest(payload) {
    try {
        const response = yield call(getKarieUsers, payload.questionnaireId);
        yield put(actions.fetchKarieUsersSuccess(response.karieUsers));
    } catch (error) {
        console.log(error);
    }
}

function* assignKarieUsersRequest(payload) {
    try {
        const response = yield call(assignToPatient, payload.questionnaireId, {
            assignIds: payload.assignIds,
            unassignIds: payload.unassignIds
        });
        yield put(actions.assignKarieUsersSuccess(response, response.assignments.karieUsers));
    } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
            yield put({ type: actions.ASSIGN_KARIE_USERS_ERROR, message: error.response.data.errors[0].message});
        } else {
            yield put({ type: actions.ASSIGN_KARIE_USERS_ERROR, message: "Could not assign/unassign Karie users. Please trye again later."});
        }
    }
}

function questionDeleteRequest(questionnaireId, questionId) {
    return deleteQuestion(questionnaireId, questionId);
}

function* deleteQuestionRequest({ questionnaireId, questionId, resolve, reject}) {
    try {
        const response = yield call(questionDeleteRequest, questionnaireId, questionId);
        if (response.message === "Deleted") {
            yield put(actions.fetchQuestions(questionnaireId));
            resolve();
        } else {
            //TODO: handle delete failure here
            reject();
        }

    } catch (error) {
        console.log(error);
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(actions.CREATE_QUESTIONNAIRE, createRequest),
        takeLatest(actions.EDIT_QUESTIONNAIRE, editQuestionnaireRequest),
        takeEvery(actions.FETCH_QUESTIONNAIRES, fetchRequest),
        takeLatest(actions.CREATE_QUESTION, createQuestionRequest),
        takeLatest(actions.FETCH_QUESTIONS, fetchQuestionsRequest),
        takeLatest(actions.FETCH_KARIE_USERS, fetchKarieUsersRequest),
        takeLatest(actions.ASSIGN_KARIE_USERS, assignKarieUsersRequest),
        takeLatest(actions.DELETE_QUESTIONNAIRE, deleteQuestionnaireRequest),
        takeLatest(actions.DELETE_QUESTION, deleteQuestionRequest)
    ]);
}